import { render, staticRenderFns } from "./StartOpen.vue?vue&type=template&id=01e59c93"
import script from "./StartOpen.vue?vue&type=script&lang=js"
export * from "./StartOpen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports